import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { CanComponentDeactivate } from './can-deactivate.types';

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate,
  _currentRoute,
  _currentState,
  nextState) => {
  const destination = nextState?.url || '';
  return component.canDeactivate(destination);
};
